import { ConfiguratorId } from "#models/Configurator"
import { FullName, Password } from "#models/User"
import { UserView } from "#models/UserView"
import { Email } from "#resources/lib/schema"
import { makeQueryKey } from "effect-app/client"
import { S, TaggedRequestFor } from "../lib.ts"

// codegen:start {preset: meta, sourcePrefix: src/resources/ }
const Req = TaggedRequestFor("Admin/Me")
// codegen:end

export class UpdateMe extends Req.Command<UpdateMe>()("UpdateMe", {
  name: FullName,
  email: Email,
  password: S.optionalKey(Password)
}) {}

export class GetMe extends Req.Query<GetMe>()("GetMe", {}, { success: UserView }) {}

export class SetConfiguratorFavorite extends Req.Command<SetConfiguratorFavorite>()(
  "SetConfiguratorFavorite",
  {
    configuratorId: ConfiguratorId,
    favorite: S.Boolean
  },
  {},
  (queryKey) => [{ filters: { queryKey } }, { filters: { queryKey: makeQueryKey(GetMe) } }]
) {}
